import { DocumentationPageApprovalState } from "../approvals/approval-state";
import { z } from "zod";
export const DocumentationPageApproval = z.object({
    id: z.string(),
    approvalState: DocumentationPageApprovalState,
    persistentId: z.string(),
    pageId: z.string(),
    pagePersistentId: z.string(),
    updatedByUserId: z.string(),
    designSystemVersionId: z.string(),
    updatedAt: z.coerce.date(),
    createdAt: z.coerce.date(),
});
